import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  AQLeadType,
  type CreateStoreAppointmentRequest,
  ServiceTypeCode,
} from '@service-initiation/shared-clients-tech-care-services';

import { createAppointment } from './createAppointment';
import { ErrorType } from './types';

export enum CreateStoreAppointmentErrorReason {
  SlotTaken = 'SlotTaken',
}

export type CreateStoreAppointmentResponse = {
  error?: CreateStoreAppointmentErrorReason;
  leadId?: number;
};

export const createStoreAppointment = async (
  request: CreateStoreAppointmentRequest
): Promise<CreateStoreAppointmentResponse> => {
  try {
    const res = await createAppointment({
      appointmentDateAndTimeUTC: request.appointmentDateAndTimeUTC,
      aqLeadType: AQLeadType.CarryIn,
      companyId: request.companyId,
      country: 'US',
      countryCode: 'us',
      customer: request.customerDetails,
      customerMessage: request.customerMessage,
      deviceRepairId: request.deviceRepairId,
      deviceTypeId: request.deviceTypeId,
      intentId: request.intentId,
      isInStoreAppointment: true,
      serviceTypeCode: ServiceTypeCode.CARRY_IN,
      storeId: request.storeId,
      subscribeToMarketingEmails: request.subscribeToMarketingEmails,
    });

    if (res.id) {
      return { leadId: res.id };
    } else {
      throw new Error(
        'Failed to create a store appointment, missing lead id or an unknown error'
      );
    }
  } catch (e) {
    const err = e as Error;
    const logData = { data: { error: e } };

    if (err.message === ErrorType.SlotIsTakenError) {
      logger.info(err, logData);
    } else {
      logger.error(err, logData);
    }

    throw err;
  }
};
